import { useMsal } from '@azure/msal-react';
import { Icon, ImageFit, PrimaryButton, Spinner, SpinnerSize, Stack, Text, Image, IconButton, Dialog, DialogType } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { listname } from '../../constants/global-values';
import { common, formatMessage } from '../../messages/common-items';
import { personalInformation } from '../../messages/personal-Information';
import { fetchItemById, getTokenAndListInfo, japaneseDateConverter, phoneNumFormat, useSmartBack } from '../../utils/item-helper';

export default function UserDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [item, setItem] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const goBack = useSmartBack("/");
  const [previewData, setPreviewData] = useState<{ url: string; type: "certificate" | "face"; name:string } | null>(null);
  const { Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info } = personalInformation;
  const { Labels: Lbl_Common, SuccessMessages: Success_Common, ErrorMessages: Err_Common } = common;
  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const { token, siteId, listId } = await getTokenAndListInfo(instance, listname);
        const found = await fetchItemById(token, siteId, listId, id!);
        setItem(found);
      }
      catch (error) {
        console.error("Error loading item", error);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id]);

  if (loading)
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;

  if (!item || item.length === 0)
    return <div className='no-records-container'>
      <Icon iconName="SearchData" className='no-records-icon' />
      <Text variant="large" style={{ color: "var(--color-black)" }}>
        {formatMessage(Err_Common.NOT_FOUND, "記録")}
      </Text>
    </div>
  const certificatenames: string[] = [
    "高所作業者",
    "玉掛け技能者",
    "溶接作業者",
    "解体工事作業者"
  ];
  const certificatePhotos: string[] = [
    "/images/certificate1.jpg",
    "/images/certificate2.jpg",
    "/images/certificate3.png",
    "/images/certificate4.png"
  ];
  const facePhotos: string[] = [
    "/images/avatar1.jfif",
    "/images/avatar2.jfif",
  ];

  const expiryDate = "2025年9月9日";
  return (
    <div className="background list-background">
      <div className="form-container list-box">
        <div >
          <h2>{Lbl_Personal_Info.DETAILS}</h2>
          <Stack tokens={{ childrenGap: 10 }}>
            {[
              [Lbl_Personal_Info.NAME, item.Name],
              [Lbl_Personal_Info.DATEOFBIRTH, japaneseDateConverter(item.DateOfBirth)],
              [Lbl_Personal_Info.GENDER, item.Gender],
              [Lbl_Personal_Info.ADDRESS, item.Address],
              [Lbl_Personal_Info.PHONENUMBER, item.PhoneNumber ? phoneNumFormat(item.PhoneNumber) : ""],
              [Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL, item.EmergencyPhone ? phoneNumFormat(item.EmergencyPhone) : ""],
              [Lbl_Personal_Info.EMERGENCY_NAME, item.EmergencyName],
              [Lbl_Personal_Info.EMERGENCY_RELATION, item.EmergencyRelation],
              [Lbl_Personal_Info.PARTNER_COMPANY_LBL, item.PartnerName],
              [Lbl_Personal_Info.IS_SOLE_PROPRIETOR, item.IsSoleProprietor],
              [Lbl_Personal_Info.SPECIAL_LABOR_INSURANCE, item.SpecialLaborInsurance],
              [Lbl_Personal_Info.BLOOD_TYPE, item.BloodType],
              [Lbl_Personal_Info.HEALTH_CHECK_DATE, japaneseDateConverter(item.HealthCheckDate)],
              [Lbl_Personal_Info.JOB_TYPE, item.JobType],
              [Lbl_Personal_Info.QUALIFICATIONS, item.Qualifications],
              [Lbl_Personal_Info.QUALIFICATION_EXPIRY, japaneseDateConverter(item.QualificationExpiry)],
              // [Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL, item.CertificatePhotos],
              // [Lbl_Personal_Info.FACE_PHOTOS_LBL, item.FacePhotos],
            ].map(([label, value]) => (
              <Stack horizontal tokens={{ childrenGap: 10 }} key={label}>
                <Text className="label-text">
                  {label}:
                </Text>
                <Text className="value-text">
                  {value || "-"}
                </Text>
              </Stack>
            ))}

            <Stack tokens={{ childrenGap: 15 }}>
              {/* Certificate Photos */}
              <Stack tokens={{ childrenGap: 5 }}>
                <Text className="label-text">{Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}</Text>
                <Stack horizontal wrap tokens={{ childrenGap: 10 }}>
                  {Array.isArray(certificatePhotos) && certificatePhotos.length > 0 ? (
                    certificatePhotos.map((url: string, i: number) => (
                      <Image
                        src={url}
                        alt={`Certificate ${i + 1}`}
                        width={100}
                        height={80}
                        imageFit={ImageFit.cover}
                        styles={{
                          root: { border: "1px solid #ddd", borderRadius: 4 },
                        }}
                        onClick={() => setPreviewData({ url, type: "certificate", name: certificatenames[i]})}
                      />
                    ))
                  ) : (
                    <Text className="value-text">{Success_Personal_Info.NO_IMAGE_SELECTED}</Text>
                  )}
                </Stack>
              </Stack>

              {/* Face Photos */}
              <Stack tokens={{ childrenGap: 5 }}>
                <Text className="label-text">{Lbl_Personal_Info.FACE_PHOTOS_LBL}</Text>
                <Stack horizontal wrap tokens={{ childrenGap: 10 }}>
                  {Array.isArray(facePhotos) && facePhotos.length > 0 ? (
                    facePhotos.map((url: string, i: number) => (
                      <Image
                        src={url}
                        alt="Face Photo"
                        width={100}
                        height={80}
                        imageFit={ImageFit.cover}
                        styles={{
                          root: { border: "1px solid #ddd", borderRadius: 4 },
                        }}
                        onClick={() => setPreviewData({ url: url, type: "face",name:"" })}
                      />
                    ))
                  ) : (
                    <Text className="value-text">{Success_Personal_Info.NO_IMAGE_SELECTED}</Text>
                  )}
                </Stack>
              </Stack>
            </Stack>
            {previewData && (
              <Dialog
                hidden={!previewData}
                onDismiss={() => setPreviewData(null)}
                dialogContentProps={{
                  type: DialogType.normal,
                }}
                modalProps={{ isBlocking: false }}
                styles={{
                    main: { borderRadius: 10 },
                  }}
              >
                <IconButton
                  iconProps={{ iconName: "Cancel" }}
                  className="imagePreviewClose imagePreviewDialogClose"
                  onClick={() => setPreviewData(null)}
                />
                <Stack tokens={{ childrenGap: 4 }}>
                  <Text
                    variant="mediumPlus"
                    styles={{ root: { fontWeight: 400 } }}
                  >
                    {previewData.type === "certificate"
                      ? `保有資格: ${previewData.name}`
                      : ``}
                  </Text>
                  {previewData.type === "certificate" && (
                    <Text variant="mediumPlus">資格期限: {expiryDate}</Text>
                  )}
                </Stack>
                <img
                  src={previewData.url}
                  alt="Preview"
                  className="imagePreviewDialog"
                />
              </Dialog>
            )}
            <Stack horizontal className="buttonallign" tokens={{ childrenGap: 10 }}>
              <PrimaryButton className="custom-primary-button" text={Lbl_Common.EDIT} onClick={() => navigate(`/shokai/henshuu/${item.id}`, { state: { from: "editshokai" } })} />
              <PrimaryButton className="cancel-button" text={Lbl_Common.CLOSE} onClick={goBack} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
}